import { useEffect, useState } from "react";
import { api, formatApiError, formatDate } from "@/lib/api";
import { PageHeader } from "@/components/Bits";
import { toast, Toaster } from "sonner";

export default function AuditLog() {
    const [logs, setLogs] = useState([]);
    useEffect(() => {
        (async () => {
            try { const { data } = await api.get("/audit-log", { params: { limit: 500 }}); setLogs(data); }
            catch (e) { toast.error(formatApiError(e)); }
        })();
    }, []);
    return (
        <>
            <Toaster richColors position="top-right" />
            <PageHeader title="Audit log" sub="Every create, edit, confirmation and reversal — timestamped and attributable." />
            <div className="p-8">
                <div className="bg-white border rounded-md overflow-hidden" style={{ borderColor: "var(--se-border)" }}>
                    <table className="se-table" data-testid="audit-table">
                        <thead><tr><th>When</th><th>Who</th><th>Action</th><th>Entity</th><th>Details</th></tr></thead>
                        <tbody>
                            {logs.length === 0 ? <tr><td colSpan="5" className="text-stone-500 py-8 text-center">No activity yet.</td></tr> :
                                logs.map((l) => (
                                    <tr key={l.id} data-testid={`audit-${l.id}`}>
                                        <td className="font-mono text-xs">{l.created_at?.slice(0, 19).replace("T", " ")}</td>
                                        <td>{l.user?.name || l.user?.email || l.user_id?.slice(0, 6)}</td>
                                        <td className="text-xs uppercase tracking-widest">{l.action}</td>
                                        <td className="text-xs text-stone-500">{l.entity_type} · {l.entity_id?.slice(0, 8)}</td>
                                        <td className="text-xs text-stone-500 max-w-md truncate" title={JSON.stringify(l.details)}>{JSON.stringify(l.details)}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
